import { render, staticRenderFns } from "./upload-document.vue?vue&type=template&id=61af4d71&scoped=true"
import script from "./upload-document.vue?vue&type=script&lang=js"
export * from "./upload-document.vue?vue&type=script&lang=js"
import style0 from "./upload-document.vue?vue&type=style&index=0&id=61af4d71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af4d71",
  null
  
)

export default component.exports